import { render, staticRenderFns } from "./CardTarjaLivesGlobo2.vue?vue&type=template&id=b2dc3c66&scoped=true"
import script from "./CardTarjaLivesGlobo2.vue?vue&type=script&lang=js"
export * from "./CardTarjaLivesGlobo2.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaLivesGlobo2.vue?vue&type=style&index=0&id=b2dc3c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc3c66",
  null
  
)

export default component.exports